<div class="progress-step">
    <span
        class="progress-step__icon"
        [ngClass]="statusClass">
        @switch (state) {
            @case ('completed') { ✓ }
            @case ('running') {
                <span class="progress-step__spinner"></span>
            }
            @case ('error') { ✕ }
            @default { ○ }
        }
    </span>

    <span
        class="progress-step__label"
        [ngClass]="statusClass">
        {{ label }}
    </span>

    @if (details && state === 'running') {
        <span class="progress-step__details">{{ details }}</span>
    }
</div>
